import React from "react";
import { BoxProps, Box } from "@mui/material";
import { deepmerge } from "@mui/utils";
import InputLabel from "@mui/material/InputLabel";
import FormStyles from "./FormStyles";

interface FormFieldLabelProps {
  children: React.ReactElement | string | (React.ReactElement<any> | string)[];
  containerProps?: ContainerProps;
  isOptional?: boolean;
  id: string
}

type ContainerProps = Partial<BoxProps>;
const defaultContainerProps: ContainerProps = {};

export const FormFieldLabel = ({
  children,
  containerProps = {},
  isOptional = false,
  id
}: FormFieldLabelProps) => {
  const mergedContainerProps = deepmerge(defaultContainerProps, containerProps);
  const classes = FormStyles();

  return (
    <Box {...mergedContainerProps}>
      <InputLabel
        htmlFor={id}
        className={classes.inputLabelStyle}
      >
        {children}
        {isOptional && <span style={{ fontWeight: "normal" }}> (Optional)</span>}
      </InputLabel>
    </Box>
  );
};
